import React, { useEffect, useMemo, useState } from "react";
import { getUNListTypes } from "common/services/sanctions-list.service";
import { normalize } from "common/lib/normalize";
import { FilterValueSelect } from "Components/Common/TableFilters";

type UNListTypeFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const UNListTypeFilter = ({ onChange, value }: UNListTypeFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getUNListTypes();

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    const uniqueOptions = new Set();
    return data
      .map((el: any) => {
        return {
          value: el?.unListType,
          label: el?.unListType,
        };
      })
      .filter((option) => {
        if (uniqueOptions.has(option.value)) {
          return false;
        } else {
          uniqueOptions.add(option.value);
          return true;
        }
      });
  }, [data]);

  return (
    <FilterValueSelect
      id="unListTypeFilter"
      placeholder="Select UN List Type"
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
    />
  );
};

export default UNListTypeFilter;
